const css = require('./user-shared-data-form.css');
const { Text, Radio, Select } = require('account-ui');
const { inputText, blurText } = require('../../../../signals/form');
const SCHEMES = require('../../../../helpers/scheme');
const signalsUtils = require('../../../../signals/utils');

class UserForm {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, this.$context.props, { css }));
    }
}

module.exports = function (formPath, signalSelectUserType, signalSelectCounty) {
    return {
        constructor: UserForm,
        children: [
            {
                name: 'text-email',
                component: Text,
                props: {
                    signals: { inputText, blurText },
                    position: 'leftToRight'
                },
                watcher: {
                    value: formPath.concat(['form', 'email'])
                }
            },
            {
                name: 'text-first-name',
                component: Text,
                props: {
                    signals: { inputText, blurText },
                    position: 'leftToRight',
                    scheme: SCHEMES.firstName
                },
                watcher: {
                    value: formPath.concat(['form', 'firstName']),
                    error: formPath.concat(['error', 'firstName'])
                }
            },
            {
                name: 'text-middle-name',
                component: Text,
                props: {
                    signals: { inputText, blurText }
                },
                watcher: {
                    value: formPath.concat(['form', 'middleName'])
                }
            },
            {
                name: 'text-last-name',
                component: Text,
                props: {
                    signals: { inputText, blurText },
                    position: 'leftToRight',
                    scheme: SCHEMES.lastName
                },
                watcher: {
                    value: formPath.concat(['form', 'lastName']),
                    error: formPath.concat(['error', 'lastName'])
                }
            },
            {
                name: 'text-org',
                component: Text,
                props: {
                    signals: { inputText, blurText }
                },
                watcher: {
                    value: formPath.concat(['form', 'organization'])
                }
            },
            {
                name: 'text-phone',
                component: Text,
                props: {
                    signals: { inputText, blurText },
                    mask: '+7(999)999-99-99'
                },
                watcher: {
                    value: formPath.concat(['form', 'phone'])
                }
            },
            {
                name: 'text-city',
                component: Text,
                props: {
                    signals: { inputText, blurText }
                },
                watcher: {
                    value: formPath.concat(['form', 'city'])
                }
            },
            {
                name: 'user-type',
                component: Radio,
                props: {
                    signal: signalSelectUserType
                },
                watcher: (attributes) => ({
                    value: formPath.concat(['userTypeRadio', attributes['cat-key']])
                })
            },
            {
                name: 'country-dropdown',
                component: Select,
                props: {
                    signalOnSelect: signalSelectCounty,
                    signalOnToggle: signalsUtils.togglePopupFromArgs
                },
                watcher: {
                    options: formPath.concat(['computed', 'countryDropdown', 'options']),
                    isDisabled: formPath.concat(['computed', 'countryDropdown', 'isDisabled']),
                    isOpen: formPath.concat(['popups', 'countryDropdown', 'isOpen']),
                    header: formPath.concat(['computed', 'countryDropdown', 'header'])
                }
            }]
    };
};



// WEBPACK FOOTER //
// ./components/common/user/user-shared-data-form/index.js